export const editRegulationsRequestsType = {
  "تعديل احكام استعمال": 2,
  "تعديل استعمال قطع": 1,
};
export const editRegulationsRequestsStatus = {
  "تحت المعالجة": 1,
  مرفوض: 2,
  معتمد: 3,
};
